type AttorneyFee = string | number | null | undefined;

export const isOneThirdAttorneyFee = (fee: AttorneyFee) => {
  if (
    typeof fee === "string" &&
    ["33 1/3", "33 ⅓", "33⅓"].includes(fee.trim())
  ) {
    return true;
  }
  const percentage = Number(fee);
  return percentage === 33.33 || percentage === 100 / 3;
};

export const formatAttorneyFee = (fee?: AttorneyFee) => {
  if (fee == null || fee === "") return "-";
  return isOneThirdAttorneyFee(fee) ? "33 1/3" : fee.toString();
};

export const calculateAttorneyFee = (
  amount: number | string,
  fee: AttorneyFee,
) => {
  const amountInCents = Math.round(Number(amount) * 100);
  const feeInCents = isOneThirdAttorneyFee(fee)
    ? amountInCents / 3
    : (amountInCents * Number(fee ?? 0)) / 100;
  return Math.round(feeInCents) / 100;
};
